// src/pages/meeting/FinancialApprovalPage.js
import React from "react";
import FormWrapper from "../../forms/shared/FormWrapper";
import InvitationFinancialApprovalForm from "../../forms/meeting/Invitation to the Financial Approval Meeting/InvitationtotheFinancialApprovalMeeting";

function FinancialApprovalPage() {
  return (
    <FormWrapper
      title="เชิญประชุมมติธรรมดา"
      FormComponent={InvitationFinancialApprovalForm}
      formKey="InvitationFinancialApproval"
    />
  );
  }

export default FinancialApprovalPage;
